<template>
  <div>
    <!-- 删除弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleObj.Delete"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p v-if="deleteType == 'null'">当前还未选择考生，请选择考生!</p>
          <p v-if="deleteType == 0">此操作将批量删除考生，是否继续?</p>
          <p v-else-if="deleteType == 1">
            此操作将删除"<span>{{ userName }}</span
            >"考生，是否继续?
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.Delete = false">取 消</el-button>
          <el-button type="primary" :loading="sundflag" @click="deleteDetermine"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="modify">
      <el-dialog
        title="重命名"
        :visible.sync="dialogVisibleObj.modifyL"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>评分表名称：</p>
          <el-input v-model="titleName"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.modifyL = false">取 消</el-button>
          <el-button type="primary" @click="rename" :loading="sundflag"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 编辑 -->
    <div class="editor">
      <el-dialog
        title="编辑"
        :visible.sync="dialogVisibleObj.editor"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>当前考核中，只能编辑时间！</p>
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期"
            :picker-options="pickerOptions0"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleObj.editor = false">取 消</el-button>
          <el-button type="primary" @click="editorClick" :loading="sundflag"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 批量导入评分表 -->
    <div class="importTable">
      <el-dialog
        title="批量导入评分表"
        :visible.sync="dialogVisibleObj.importTable"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <div class="first_step">
            <p>第一步：下载评分表模板，并编辑评分表</p>
            <el-button @click="downloadClick(2)"> 点击下载二层级模板</el-button>
            <el-button @click="downloadClick(3)">点击下载三层级模板</el-button>
          </div>
          <div class="second_step">
            <p>第二步：导入文件</p>
            <el-input
              placeholder="请选择需要导入的文件"
              class="check_input"
              v-model="textFile"
              readonly
            ></el-input>
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :multiple="false"
              :limit="1"
              accept=".xls, .xlsx"
              :show-file-list="false"
              :on-change="uploadPreview"
              :auto-upload="false"
            >
              <el-button type="primary" icon="el-icon-upload2" class="upoload"
                >上传文件</el-button
              >
            </el-upload>
          </div>
          <p class="description">
            说明：导入文件类型必须为.xls或.xlsx格式，评分表名称为导入表格的文件名
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="importTableClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import assessApi from "@/api/assessment";
import loginvuex from "@/store/index";

export default {
  props: [
    "statePopupstatus",
    "deleteType",
    "userName",
    "deleteNum",
    "deleteDetermine",
    "rowObj",
    "renameClick",
    "editorfun",
    "getDatalist"
  ],
  data() {
    return {
      dialogVisibleObj: {
        Delete: false,
        modifyL: false, //修改弹窗
        editor: false, // 编辑
        importTable: false, // 批量导入评分表
      },
      textFile: "", // 文件上传文件名
      // 禁用当前前面的时间日期
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      time: [], // 时间
      sundflag: false, // 结束考试防抖
      titleName: "",
      filedata: "", // 上传的文件
    };
  },
  methods: {
    rename() {
      this.renameClick();
    },
    // 取消导入
    cancelClick() {
      this.textFile = "";
      this.filedata = "";
      this.$refs.upload.clearFiles();
      this.dialogVisibleObj.importTable = false;
    },
    // 编辑
    editorClick() {
      this.editorfun();
    },
    // 批量导入
    async importTableClick() {
      if (this.filedata != "") {
        let formData = new FormData();
        formData.append("file", this.filedata.raw);
        formData.append(
          "userID",
          JSON.parse(loginvuex.state.userlist).userID
        );
        formData.append(
          "guid",
          JSON.parse(loginvuex.state.userlist).guid
        );
        const { data } = await assessApi.uploadRating(formData);
        if (data.Status == 200) {
          this.$message({
            type: "success",
            message: `${this.textFile}评分表导入成功`,
          });
          this.textFile = "";
          this.filedata = "";
          this.$refs.upload.clearFiles();
          this.getDatalist() // 刷新列表
          this.dialogVisibleObj.importTable = false;
        } else {
          this.$message.error({
            message: data.Msg,
            type: "warning",
          });
          this.textFile = "";
          this.filedata = "";
          this.$refs.upload.clearFiles();
        }
      } else {
        this.$message({
          message: "请选择要导入的文件",
          type: "warning",
        });
      }
    },
    uploadPreview(file) {
      //文件上传，增加进度条，
      this.textFile = file.name;
      let filetype = file.name.split(".");
      filetype = filetype[filetype.length - 1]; //文件类型。
      if (filetype != "xls" && filetype != "xlsx") {
        this.$message({
          message: "文件格式不合法",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      } else if (file.raw.size > 104857600) {
        this.$message({
          message: "文件大小不能超过100MB",
          type: "warning",
        });
        this.textFile = "";
        this.$refs.upload.clearFiles();
        return;
      }
      //开始进行base64转码
      this.filedata = file;
      this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
    },
    downloadClick(type) {
      const link = document.createElement("a");
      if (type == 2) {
        link.setAttribute("download", "二级评分表模板.xls");
        link.href = "ejpfb.xls";
        link.click();
      } else if (type == 3) {
        link.setAttribute("download", "三级评分表模板.xls");
        link.href = "sjpfb.xls";
        link.click();
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    p {
      text-align: center;
      span {
        color: red;
      }
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 300px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
}
.editor {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      text-align: center;
      color: red;
      margin-bottom: 22px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 120px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
.importTable {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 48px;
  }
  .mian {
    .first_step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > .el-button {
        background: #0084ea;
        color: #fff;
      }
    }
    .second_step {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      margin-top: 32px;
      p {
        margin-right: 12px;
      }
      .el-button {
        margin-left: 22px;
      }
      .el-input {
        width: 340px;
      }
    }
    .description {
      color: red;
      text-align: center;
      margin-top: 24px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 660px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
}
</style>
